import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./payment.html';
import controller from './paymentCtrl';
import styles from './payment-hashed.scss';

/**
 * @ngdoc component
 * @name gw-payment
 *
 * @description  A component to display a BOP Renewal payment detail page into a wizard flow
 *
 */
export default {
  controller: controller,
  template: cssUtil.hashTemplate(template, styles)
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/paymentWithPaymentPlan/index.js
// module id = 1007
// module chunks = 0